const BASE = process.env.REACT_APP_API_URL || '/api';

function authHeader() {
  const token = localStorage.getItem('auth_token');
  return token ? { 'Authorization': `Bearer ${token}` } : {};
}

function handleUnauth() {
  localStorage.removeItem('auth_token');
  localStorage.removeItem('auth_expiry');
  window.dispatchEvent(new Event('auth:logout'));
}

export const api = {
  async get(path) {
    const r = await fetch(`${BASE}${path}`, { headers: authHeader() });
    if (r.status === 401) { handleUnauth(); throw new Error('Niet ingelogd'); }
    if (!r.ok) throw new Error(await r.text());
    return r.json();
  },
  async post(path, body) {
    const r = await fetch(`${BASE}${path}`, { method: 'POST', headers: { 'Content-Type': 'application/json', ...authHeader() }, body: JSON.stringify(body) });
    if (r.status === 401) { handleUnauth(); throw new Error('Niet ingelogd'); }
    if (!r.ok) throw new Error(await r.text());
    return r.json();
  },
  async put(path, body) {
    const r = await fetch(`${BASE}${path}`, { method: 'PUT', headers: { 'Content-Type': 'application/json', ...authHeader() }, body: JSON.stringify(body) });
    if (r.status === 401) { handleUnauth(); throw new Error('Niet ingelogd'); }
    if (!r.ok) throw new Error(await r.text());
    return r.json();
  },
  async delete(path) {
    const r = await fetch(`${BASE}${path}`, { method: 'DELETE', headers: authHeader() });
    if (r.status === 401) { handleUnauth(); throw new Error('Niet ingelogd'); }
    if (!r.ok) throw new Error(await r.text());
    return r.json();
  },
};

export async function uploadImage(file) {
  const formData = new FormData();
  formData.append('image', file);
  const r = await fetch('/api/upload-image', { method: 'POST', headers: authHeader(), body: formData });
  if (r.status === 401) { handleUnauth(); throw new Error('Niet ingelogd'); }
  if (!r.ok) throw new Error(await r.text());
  return r.json();
}

export function getExpiryStatus(expiryDate, warningDays = 7) {
  if (!expiryDate) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const exp = new Date(expiryDate);
  const diffDays = Math.ceil((exp - today) / (1000 * 60 * 60 * 24));
  if (diffDays < 0) return { status: 'danger', label: `Verlopen (${Math.abs(diffDays)}d)`, days: diffDays };
  if (diffDays === 0) return { status: 'danger', label: 'Verloopt vandaag', days: 0 };
  if (diffDays <= warningDays) return { status: 'warn', label: `Verloopt over ${diffDays}d`, days: diffDays };
  return { status: 'ok', label: `Nog ${diffDays} dagen`, days: diffDays };
}

export function formatDate(dateStr) {
  if (!dateStr) return '—';
  return new Date(dateStr).toLocaleDateString('nl-BE', { day: '2-digit', month: '2-digit', year: 'numeric' });
}
